// data/items/jewelry.js
// Jewelry items crafted from gems and gold bars
// Bands = ring slot (attack, spell damage, defense, crit at higher tiers)
// Pendants = neck slot (speed, defense, accuracy at higher tiers)

// Bands - gem + gold bar - Ring slot
// Stats: attackBonus (melee/ranged), spellDamage (magic %), defenseBonus, critChance (T4+)
export const BANDS = [
    {
        id: 'sapphire_band',
        name: 'Sapphire Band',
        color: '#0f52ba',
        value: 220,
        slot: 'ring',
        combatLevel: 1,
        attackBonus: 2,
        spellDamage: 0.02,
        defenseBonus: 1
    },
    {
        id: 'emerald_band',
        name: 'Emerald Band',
        color: '#50c878',
        value: 320,
        slot: 'ring',
        combatLevel: 15,
        attackBonus: 4,
        spellDamage: 0.03,
        defenseBonus: 2
    },
    {
        id: 'ruby_band',
        name: 'Ruby Band',
        color: '#e0115f',
        value: 450,
        slot: 'ring',
        combatLevel: 30,
        attackBonus: 6,
        spellDamage: 0.04,
        defenseBonus: 3
    },
    {
        id: 'diamond_band',
        name: 'Diamond Band',
        color: '#b9f2ff',
        value: 600,
        slot: 'ring',
        combatLevel: 45,
        attackBonus: 8,
        spellDamage: 0.05,
        defenseBonus: 4,
        critChance: 2
    },
    {
        id: 'astryx_stone_band',
        name: 'Astryx Stone Band',
        color: '#9932cc',
        value: 800,
        slot: 'ring',
        combatLevel: 60,
        attackBonus: 10,
        spellDamage: 0.06,
        defenseBonus: 5,
        critChance: 3
    },
    {
        id: 'onyx_band',
        name: 'Onyx Band',
        color: '#353839',
        value: 1050,
        slot: 'ring',
        combatLevel: 75,
        attackBonus: 12,
        spellDamage: 0.07,
        defenseBonus: 6,
        critChance: 4
    }
];

// Pendants - gem + gold bar + spun fiber - Neck slot
// Stats: speedBonus (attack speed %), defenseBonus, accuracy (T4+)
export const PENDANTS = [
    {
        id: 'sapphire_pendant',
        name: 'Sapphire Pendant',
        color: '#0f52ba',
        value: 350,
        slot: 'neck',
        combatLevel: 1,
        speedBonus: 2,
        defenseBonus: 2
    },
    {
        id: 'emerald_pendant',
        name: 'Emerald Pendant',
        color: '#50c878',
        value: 500,
        slot: 'neck',
        combatLevel: 15,
        speedBonus: 3,
        defenseBonus: 4
    },
    {
        id: 'ruby_pendant',
        name: 'Ruby Pendant',
        color: '#e0115f',
        value: 700,
        slot: 'neck',
        combatLevel: 30,
        speedBonus: 4,
        defenseBonus: 6
    },
    {
        id: 'diamond_pendant',
        name: 'Diamond Pendant',
        color: '#b9f2ff',
        value: 950,
        slot: 'neck',
        combatLevel: 45,
        speedBonus: 5,
        defenseBonus: 8,
        accuracy: 3
    },
    {
        id: 'astryx_stone_pendant',
        name: 'Astryx Stone Pendant',
        color: '#9932cc',
        value: 1250,
        slot: 'neck',
        combatLevel: 60,
        speedBonus: 6,
        defenseBonus: 10,
        accuracy: 4
    },
    {
        id: 'onyx_pendant',
        name: 'Onyx Pendant',
        color: '#353839',
        value: 1600,
        slot: 'neck',
        combatLevel: 75,
        speedBonus: 7,
        defenseBonus: 12,
        accuracy: 5
    }
];

// HD jewelry icons (assets/icons/crafting/jewelry/). Add entries as art arrives.
// Map item id -> file name (astryx files drop the "stone" infix from the item id).
const PENDANT_ART = {
    sapphire_pendant: 'sapphire_pendant',
    emerald_pendant: 'emerald_pendant',
    ruby_pendant: 'ruby_pendant',
    diamond_pendant: 'diamond_pendant',
    astryx_stone_pendant: 'astryx_pendant',  // file name shortened from item id
    onyx_pendant: 'onyx_pendant'
};
const BAND_ART = {
    sapphire_band: 'sapphire_band',
    emerald_band: 'emerald_band',
    ruby_band: 'ruby_band',
    diamond_band: 'diamond_band',
    astryx_stone_band: 'astryx_band',  // file name shortened from item id
    onyx_band: 'onyx_band'
};
for (const p of PENDANTS) {
    const file = PENDANT_ART[p.id];
    if (file) {
        p.sprite = { sheet: `assets/icons/crafting/jewelry/${file}.png`, x: 0, y: 0, width: 64, height: 64 };
    }
}
for (const b of BANDS) {
    const file = BAND_ART[b.id];
    if (file) {
        b.sprite = { sheet: `assets/icons/crafting/jewelry/${file}.png`, x: 0, y: 0, width: 64, height: 64 };
    }
}

export default { BANDS, PENDANTS };
